import ApiService from '@/common/api.service'
import { getDataVersion } from '../utils'

/* eslint-disable */
const getDefaultState = () => {
  return {
  }
}

const state = getDefaultState()

const getters = {
}

const mutations = {
}

const actions = {
  fetchAllPagination({ rootState }, queryParams) {
    return new Promise((resolve, reject) => {
      queryParams.dataVersion = getDataVersion(rootState)
      ApiService.get('PresetAncientPeriod/pagination', queryParams, this)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },

  fetchAll({ rootState }, queryParams) {
    return new Promise((resolve, reject) => {
      queryParams.dataVersion = getDataVersion(rootState)
      ApiService.get('PresetAncientPeriod', queryParams, this)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },
  
  fetch({ rootState }, queryParams) {
    return new Promise((resolve, reject) => {
      ApiService.get(`PresetAncientPeriod/${queryParams.id}`, queryParams, this)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },

  save({ rootState }, queryParams) {
    return new Promise((resolve, reject) => {
      queryParams.dataVersion = getDataVersion(rootState)
      ApiService.post('PresetAncientPeriod', queryParams, this)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },

  remove({ rootState }, queryParams) {
    return new Promise((resolve, reject) => {
      ApiService.get(`PresetAncientPeriod/delete/${queryParams.id}`, {}, this)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
